import { render } from "./ModalChangePage.vue?vue&type=template&id=687b29c2&scoped=true"
import script from "./ModalChangePage.vue?vue&type=script&lang=js"
export * from "./ModalChangePage.vue?vue&type=script&lang=js"

import "./ModalChangePage.vue?vue&type=style&index=0&id=687b29c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687b29c2"]])

export default __exports__